export var EventType;
(function (EventType) {
    EventType["User"] = "UserAction";
    EventType["System"] = "SystemAction";
    EventType["Aware"] = "AwareAction";
})(EventType || (EventType = {}));
//# sourceMappingURL=UsageEvent.js.map